import {Tarea, FiltroTarea} from "../modelo/Tarea";

export const CONSULTAR_TAREAS = "CONSULTAR_TAREAS";
export const TAREAS_CONSULTADAS = "TAREAS_CONSULTADAS";
export const ERROR_CONSULTANDO_TAREAS = "ERROR_CONSULTANDO_TAREAS";
export const REINTENTAR_TAREA = "REINTENTAR_TAREA";
export const REINTENTO_ENVIADO = "REINTENTO_ENVIADO";
export const ERROR_REINTENTANDO_TAREA = "ERROR_REINTENTANDO_TAREA";

export const consultarTareas = (filtroTarea: FiltroTarea) => ({type: CONSULTAR_TAREAS, filtroTarea});
export const tareasConsultadas = (tareas: Array<Tarea>,
                                  paginas: number) => ({type: TAREAS_CONSULTADAS, tareas, paginas});
export const errorConsultandoTareas = () => ({type: ERROR_CONSULTANDO_TAREAS});
export const reintentarTarea = (dni: string, tipoCliente: string, dniAprueba: string) => ({type: REINTENTAR_TAREA, dni, tipoCliente, dniAprueba});
export const reintentoEnviado = () => ({type: REINTENTO_ENVIADO});
export const errorReintentandoTarea = () => ({type: ERROR_REINTENTANDO_TAREA});


// WEBPACK FOOTER //
// ./src/co/sura/dominio/bandeja/modulos/bandejaActions.ts